export const introductionModalConfig = {
  width: '55rem',
  dismissableMask: true,
  closeOnEscape: true,
  closable: true,
  showHeader: false,
};
